import React from "react"
import { IS_USING_CHRISTMAS_THEME } from "../../../shared/config/consts"

const LoginLogo = () => (
    <div className="w-full flex flex-row items-center -center justify-center p-28 z-50">
        <img src={"./images/logo.svg"} className="h-36" alt={"FINWAY"} />
        {IS_USING_CHRISTMAS_THEME && <img src="/images/snow_man.png" alt="finway snow man" className="w-32" />}
    </div>
)

export default LoginLogo
